<mat-toolbar style="background-color: #fff; border-top: 1px solid #ddd; border-bottom: 1px solid #ddd;">
  <span>{{ sidebarTitle }}</span>
</mat-toolbar>
<div class="content">
  <h2>Group: {{ addFieldSideBarGroupTitle | translate: 'Text' | async }}</h2>
  <div class="form">
    <div>
      <mat-form-field class="medium-field">
        <mat-label>Field Type</mat-label>
        <mat-select class="mat-primary" [(ngModel)]="selectedValue" (selectionChange)="onFieldTypeChanged()" [disabled]="editMode" id="field-type-dropdown">
          @for (fieldType of fieldTypes; track fieldType) {
            <mat-option
              [class.selected]="fieldType === fieldForm.FieldType"
              [value]="fieldType"
              id="field-type-dropdown-{{fieldType}}">
              <span>{{fieldType}}</span>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="state-validation-errors">{{fieldTypeError}}</div>
    <div class="state-validation-errors">{{errorString}}</div>
    <div>
      <mat-form-field class="medium-field">
        <mat-label>Field Id</mat-label>
        <input matInput [disabled]="editMode" (input)="updateFieldId(fieldForm.FieldId)" [(ngModel)]="fieldForm.FieldId" value="" id="field-id-input" />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field class="medium-field">
        <mat-label>Label</mat-label>
        <input matInput [disabled]="editMode" [(ngModel)]="fieldForm.FieldName" value="" id="field-label-input" />
      </mat-form-field>
    </div>
    @if (selectedValue !== 'label') {
      <div>
        <mat-form-field class="medium-field">
          <mat-label>Help Text</mat-label>
          <input matInput [disabled]="editMode" [(ngModel)]="fieldForm.HelpText" value="" id="field-help-text-input" />
        </mat-form-field>
      </div>
    }
    <div [hidden]="isTreeControl() || isMandatoryShouldNotBeSelectableForFieldType()">
      <mat-checkbox id="field-is-mandatory-input" [(ngModel)]="fieldForm.IsMandatory" value="">
        Is Mandatory?
      </mat-checkbox>
    </div>
    @if (selectedValue === 'list') {
      <div>
        <div>
          <br />
          <mat-form-field class="medium-field">
            <mat-label>List Alias</mat-label>
            <mat-select matInput #listAliasFieldSelection="ngModel"
              [(ngModel)]="listAlias"
              id="field-list-alias-dropdown">
              @for (list of lists; track list) {
                <mat-option
                  [value]="list.Key"
                  id="field-list-alias-dropdown-{{list.Key}}">
                  {{list.FriendlyName}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <button mat-button
            color="primary"
            (click)="manageListItems()"
            [disabled]="disableManageListItems()"
            id="manage-list-items-button">
            <mat-icon>list</mat-icon>
            <span>Manage List Items</span>
          </button>
        </div>
        <div>
          <button mat-button
            color="primary"
            (click)="addList()"
            id="add-list-button">
            <mat-icon>list</mat-icon>
            <span>Add New List...</span>
          </button>
        </div>
        <br />
      </div>
    }
    @if (selectedValue === 'list') {
      <div>
        <app-list-type id="field-list-restrict"
          [editMode]=editMode
          [singleListTypes]=singleListTypes
          [isOfTypes]=isOfTypes
          [isOfType]=isOfType
          [(ngModel)]="isOfType">
        </app-list-type>
      </div>
    }
    @if (selectedValue === 'simpleuserlist') {
      <div>
        <app-list-type id="field-list-restrict"
          [editMode]=editMode
          [singleListTypes]=simpleUserListSingleListTypes
          [isOfTypes]=simpleUserListIsOfTypes
          [isOfType]=isOfType
          [(ngModel)]="isOfType">
        </app-list-type>
      </div>
    }
    @if (selectedValue === 'list') {
      <div>
        <mat-form-field class="medium-field">
          <mat-label>Filter By Lookup</mat-label>
          <mat-select class="mat-primary" [(ngModel)]="fieldFilterName" id="field-filter-name-dropdown">
            @for (lookup of lookupFields; track lookup) {
              <mat-option
                [value]="lookup.FieldId"
                id="field-filter-name-dropdown-{{lookup.FieldId}}">
                <span>{{lookup.FieldName}}</span>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (selectedValue === 'text') {
      <div>
        <mat-form-field class="medium-field">
          <mat-label>Minimum Characters</mat-label>
          <input matInput type="number" [(ngModel)]="fieldForm.MinChars" value="0" id="field-min-characters">
        </mat-form-field>
      </div>
    }
    @if (selectedValue === 'text') {
      <div>
        <mat-form-field class="medium-field">
          <mat-label>Maximum Characters</mat-label>
          <input matInput type="number" [(ngModel)]="fieldForm.MaxChars" value="0" id="field-max-characters">
        </mat-form-field>
      </div>
    }
    @if (selectedValue === 'text') {
      <div>
        <mat-checkbox id="field-is-multiline" [(ngModel)]="fieldForm.IsMultiLine" (change)="onMultilineFieldChange()" value="">
          Is Multiline?
        </mat-checkbox>
      </div>
    }
    @if (selectedValue === 'text' && fieldForm.IsMultiLine) {
      <div>
        <mat-checkbox id="field-is-markdown" [(ngModel)]="fieldForm.IsMarkdown" value="">Is Markdown?</mat-checkbox>
      </div>
    }
    @if (selectedValue === 'number') {
      <div>
        <app-regex-number-type id="field-regex-restrict"
          [disabled]="editMode"
          [(ngModel)]="fieldForm.RegexRestrict">
        </app-regex-number-type>
      </div>
    }
    @if (selectedValue === 'datetimepicker') {
      <div>
        <mat-checkbox id="field-has-time" [(ngModel)]="fieldForm.HasTime" value="false">Include Time Fields?</mat-checkbox>
      </div>
    }
    @if (selectedValue === 'calc') {
      <div>
        <div>
          <mat-form-field class="medium-field input-has-hint">
            <mat-label>Parent Field</mat-label>
            <mat-hint>@if (parentField && parentField.ParentPropertyName !== parentField.DisplayName) {
              <span>{{parentField.StepId}}<br /> ({{parentField.ParentPropertyName}})</span>
            }</mat-hint>
            <mat-select [(ngModel)]="parentField" [compareWith]="compareSimpleFieldViewModels" (selectionChange)="getDrivingAttributes(parentField)" id="field-parent-field-dropdown">
              @for (parentField of parentFields; track parentField) {
                <mat-option [value]="parentField" id="field-parent-field-dropdown-{{parentField.ParentPropertyName}}">
                  {{parentField.DisplayName}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    }
    @if (isCalcField(selectedValue) && showDrivingAttribute) {
      <div>
        <mat-form-field class="medium-field">
          <mat-label>Driving Attribute</mat-label>
          <mat-select class="mat-primary" [(ngModel)]="drivingAttribute" id="field-driving-attribute-dropdown">
            @for (attribute of drivingAttributes; track attribute) {
              <mat-option [value]="attribute.Name" id="field-driving-attribute-dropdown-{{attribute.Name}}">
                {{attribute.Label}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (selectedValue === 'calc') {
      <div>
        <mat-form-field class="medium-field">
          <mat-label>Calculation Type</mat-label>
          <mat-select class="mat-primary" [(ngModel)]="calculationType" id="field-calc-type-dropdown">
            @for (calcType of calculationTypes; track calcType) {
              <mat-option [value]="calcType.Key" id="field-calc-type-dropdown-{{calcType.Value}}">
                {{calcType.Value}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (selectedValue === 'linkedrecord' || selectedValue === 'multilinkedrecord') {
      <div>
        <mat-form-field class="medium-field">
          <mat-label>Module To link to</mat-label>
          <mat-select class="mat-primary" [(ngModel)]="fieldForm.LinkedRecordModuleId" id="field-module-link-dropdown">
            @for (module of editableModules; track module) {
              <mat-option [value]="module.ModuleId" id="field-module-link-dropdown-{{module.ModuleId}}">
                {{module.ModuleName}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (selectedValue === 'linkedrecord' || selectedValue === 'multilinkedrecord') {
      <div>
        <mat-checkbox id="field-allow-linking-record" [(ngModel)]="fieldForm.AllowLinkingToNewRecord" value="">Allow creating new record to link</mat-checkbox>
      </div>
    }
    @if (selectedValue === 'linkedrecord' || selectedValue === 'multilinkedrecord') {
      <div>
        <mat-checkbox id="field-allow-linking-existing-record" [(ngModel)]="fieldForm.AllowLinkingToExistingRecords" value="">Allow to linking to existing record</mat-checkbox>
      </div>
    }
    @if (selectedValue === 'linkedrecord' || selectedValue === 'multilinkedrecord') {
      <div>
        <mat-form-field class="medium-field">
          <mat-label>Link description (graph view)</mat-label>
          <input matInput [disabled]="editMode" [(ngModel)]="fieldForm.RelationshipDescription" value="" id="field-relationship-description">
        </mat-form-field>
      </div>
    }
    @if (selectedValue === 'lookup') {
      <div>
        <mat-form-field class="medium-field">
          <mat-label>Type of lookup</mat-label>
          <mat-select class="mat-primary" [(ngModel)]="fieldForm.LookupType" id="field-lookup-type-dropdown">
            <mat-option value="linkedrecord" id="field-lookup-type-dropdown-linked-record">Linked Record</mat-option>
            <mat-option value="listattribute" id="field-lookup-type-dropdown-list-attribute">List Attribute</mat-option>
            <mat-option value="listitemvalue" id="field-lookup-type-dropdown-list-value">List Item Value</mat-option>
            <mat-option value="hierarchyattribute" id="field-lookup-type-dropdown-hierarchy-attribute">Hierarchy Attribute</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (selectedValue === 'lookup' && fieldForm.LookupType==='linkedrecord') {
      <div>
        <mat-form-field class="medium-field">
          <mat-label>Driving Linked Record Field</mat-label>
          <mat-select class="mat-primary"
            [(ngModel)]="fieldForm.LinkedRecordField"
            (selectionChange)="getFieldsForModule(fieldForm.LinkedRecordField.LinkedRecordModuleId)"
            [compareWith]="compareLinkedRecordField"
            id="field-driving-linked-record-dropdown">
            @for (field of linkedRecordFields; track field) {
              <mat-option [value]="field" id="field-driving-linked-record-dropdown-{{field.FieldName}}">
                {{field.FieldName}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (selectedValue === 'lookup' && fieldForm.LinkedRecordField) {
      <div>
        <mat-form-field class="medium-field">
          <mat-label>Field on Target</mat-label>
          <mat-select class="mat-primary" [(ngModel)]="fieldForm.LinkedRecordTargetField" [compareWith]="compareOtherModuleField" id="field-on-target-dropdown">
            @for (field of moduleFieldsForLookup | async; track field) {
              <mat-option [value]="field" id="field-on-target-dropdown-{{field.ParentPropertyName}}">
                {{field.DisplayName}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (selectedValue === 'lookup' && fieldForm.LookupType==='listitemvalue') {
      <div>
        <mat-form-field class="medium-field">
          <mat-label>Driving Linked Record Fields</mat-label>
          <mat-select class="mat-primary" [(ngModel)]="fieldForm.LinkedFields" multiple="true" [compareWith]="compareLinkedRecordField" id="field-driving-linked-record-fields-dropdown">
            @for (field of allListFields; track field) {
              <mat-option [value]="field" id="field-driving-linked-record-fields-dropdown-{{field.FieldName}}">
                {{field.FieldName}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (selectedValue === 'lookup' && fieldForm.LookupType==='listattribute') {
      <div>
        <mat-form-field class="medium-field">
          <mat-label>Driving Linked Record Field</mat-label>
          <mat-select class="mat-primary"
            [(ngModel)]="fieldForm.ListField"
            (selectionChange)="getListAttributesForList(fieldForm.ListField.ListAlias)"
            [compareWith]="compareLinkedRecordField"
            id="field-driving-linked-record-field-dropdown">
            @for (field of allListFields; track field) {
              <mat-option [value]="field" id="field-driving-linked-record-field-dropdown-{{field.FieldName}}">
                {{field.FieldName}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (selectedValue === 'lookup' && fieldForm.LookupType==='listattribute' && fieldForm.ListField) {
      <div>
        <mat-form-field class="medium-field">
          <mat-label>List Attribute</mat-label>
          <mat-select class="mat-primary" [(ngModel)]="fieldForm.TargetListAttribute" id="field-list-attribute">
            @for (attr of listAttributesForLookup | async; track attr) {
              <mat-option [value]="attr.Name" id="field-list-attribute-{{attr.Name}}">
                {{attr.Label}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (selectedValue === 'lookup' && fieldForm.LookupType==='hierarchyattribute') {
      <div>
        <mat-form-field class="medium-field">
          <mat-label>Hierarchy Attribute</mat-label>
          <mat-select class="mat-primary" [(ngModel)]="targetHierarchyAttribute">
            @for (attr of locationAttributes; track attr) {
              <mat-option [value]="attr.AttributeId">
                {{attr.AttributeName}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (selectedValue === 'lookup' && fieldForm.LookupType==='hierarchyattribute') {
      <div>
        <mat-checkbox id="hierarchy-keep-existing-value" [(ngModel)]="fieldForm.KeepExistingValue" value="">Keep Existing Value</mat-checkbox>
      </div>
    }
    @if (selectedValue === 'file') {
      <div>
        <mat-form-field class="medium-field">
          <mat-label>Maximum Attachments</mat-label>
          <input matInput type="number" [(ngModel)]="fieldForm.MaximumNumberOfItems" value="0">
        </mat-form-field>
      </div>
    }
    @if (selectedValue === 'escalation') {
      <div>
        <mat-form-field class="medium-field">
          <mat-label>Applicable Module Statuses</mat-label>
          <mat-select class="mat-primary" [(ngModel)]="fieldForm.EscalationApplicableModuleStatusIds" multiple="true" id="applicable-module-ids-dropdown">
            @for (status of stateNodes; track status) {
              <mat-option [value]="status.ModuleStatus.Id" id="applicable-module-ids-dropdown-{{status.Name}}">
                {{status.Name}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <p>
          {{applicableModuleStatusesError}}
        </p>
      </div>
    }
    @if (selectedValue === 'severitymatrix') {
      <div>
        <div>
          <mat-form-field class="medium-field">
            <mat-label>Mapped List Item Label</mat-label>
            <input matInput type="text" [(ngModel)]="fieldForm.MappedListItemLabel" id="severity-matrix-mapped-item-input">
          </mat-form-field>
        </div>
        <div>
          <mat-form-field class="medium-field">
            <mat-label>Matrix Name</mat-label>
            <mat-select class="mat-primary" [(ngModel)]="fieldForm.MatrixName" id="severity-matrix-name-attribute">
              @for (matrixName of matrixNames; track matrixName) {
                <mat-option [value]="matrixName" id="severity-matrix-name-attribute-{{matrixName}}">
                  {{matrixName}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    }
    @if (selectedValue === 'file') {
      <div>
        <mat-form-field class="medium-field">
          <mat-label>Allowed File Types</mat-label>
          <mat-select class="mat-primary" [(ngModel)]="fieldForm.AllowedFileTypes" multiple>
            <mat-select-trigger>
              {{fieldForm.AllowedFileTypes ? getFileTypeDisplayName(fieldForm.AllowedFileTypes[0]) : ''}}
              @if (fieldForm.AllowedFileTypes?.length > 1) {
                <span>
                  (+{{fieldForm.AllowedFileTypes.length - 1}} {{fieldForm.AllowedFileTypes?.length === 2 ? 'other' : 'others'}})
                </span>
              }
            </mat-select-trigger>
            @for (fileType of allFileTypes; track fileType) {
              <mat-option [value]="fileType">
                {{getFileTypeDisplayName(fileType)}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (selectedValue === 'label') {
      <div>
        <mat-form-field class="medium-field">
          <mat-label>Text</mat-label>
          <input matInput type="text" [(ngModel)]="fieldForm.TextValue" id="field-text-value">
        </mat-form-field>
      </div>
    }
    <div>
      <mat-checkbox id="field-render-and-hide-input" [(ngModel)]="fieldForm.RenderAndHide" value="">
        Render And Hide?
      </mat-checkbox>
    </div>
    @if (selectedValue === 'simpleuserlist') {
      <div>
        <mat-checkbox id="field-simple-user-list-permissions-filter" [(ngModel)]="simpleUserListPermissionsFilter" (ngModelChange)="updateSimpleUserListPermissionsFilter($event)">
          Filter User List By Permissions?
        </mat-checkbox>
      </div>
    }
    @if (selectedValue === 'simpleuserlist' && simpleUserListPermissionsFilter) {
      <div>
        <mat-form-field class="medium-field">
          <mat-label>Module</mat-label>
          <mat-select class="mat-primary" [(ngModel)]="selectedModule" (ngModelChange)="setSelectedModule($event)" id="selected-module-dropdown">
            @for (module of modules; track module) {
              <mat-option [value]="module" id="selected-module-dropdown-{{module}}">
                {{module}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field class="medium-field">
          <mat-label>Permission</mat-label>
          <mat-select class="mat-primary" [(ngModel)]="selectedPermission" (ngModelChange)="setSelectedPermission($event)" id="selected-permission-dropdown">
            @for (permission of getPermissionsForModule(selectedModule); track permission) {
              <mat-option [value]="permission" id="selected-permission-dropdown-{{permission.Name}}">
                {{permission.Name}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <p>
          {{simpleUserListErrorMessage}}
        </p>
      </div>
    }
    <br />
    <div>
      @if (!editMode) {
        <a mat-raised-button class="mat-accent" [disabled]="!validationPass() || isDisabled" (click)="validationPass() && saveField()" id="edit-field-save">Save</a>
      }
      @if (editMode) {
        <a mat-raised-button class="mat-accent" (click)="onUpdateFieldClick()" id="edit-field-update">Update</a>
      }
    </div>
  </div>
</div>